import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { SiteClosingCta } from '../../../../components/site';
import { PartnerPanelLink } from '../../../../components/PartnerPanelLink';
import { partnerSignupUrl } from '../../../../config/partnerPanel';
import { platformClosing } from '../../overview/data/overview';

export const PlatformClosingCta: React.FC = () => (
  <div className="platform-closing-wrap platform-closing-wrap--premium">
    <SiteClosingCta
      titleId="platform-closing-title"
      titleLines={platformClosing.titleLines}
      subtitle={platformClosing.subtitle}
      ctaAction={
        <div className="platform-closing__actions">
          <Link to={platformClosing.demoCta.to} className="io-home-closing__cta">
            {platformClosing.demoCta.label}
            <ArrowRight className="io-home-closing__cta-icon" size={20} strokeWidth={2} aria-hidden />
          </Link>
          <PartnerPanelLink to={partnerSignupUrl()} className="platform-closing__cta-secondary">
            {platformClosing.partnerCta.label}
            <ArrowRight size={20} strokeWidth={2} aria-hidden />
          </PartnerPanelLink>
        </div>
      }
    />
  </div>
);
